import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

import { CarBrand, CarModel, CarNumber, CarEnginePower, CarManufactureYear, IsOwnerCheckbox } from './fields';

export interface IPledgeAutoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TPledgeAutoFields;
}

export const FormFieldsControls: Record<keyof TPledgeAutoFields, React.ReactNode> = {
  carBrand: CarBrand,
  carManufactureYear: CarManufactureYear,
  carModel: CarModel,
  carNumber: CarNumber,
  enginePower: CarEnginePower,
  isTaxi: null,
  isOwner: IsOwnerCheckbox,
};

export const FormFieldsNavigationSequence: IPledgeAutoMobileConfig[] = [
  {
    fieldName: 'carBrand',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'carManufactureYear',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'carModel',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'carNumber',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'enginePower',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'isTaxi',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'isOwner',
    required: false,
    checkShouldMoveToNextField: false,
  },
];
